(ns hypnos.sleeplab.bar.footer
  "The footer."
  (:require [hypnos.config :as config]
            [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Bar

(defn bar
  "The footer bar."
  []
  [:footer.footer
   [:div.container-fluid
    [:div.level
     [:div.level-left
      [:div.level-item (tr :ui.label/copyright)]]
     [:div.right-left
      [:div.level-item (tr :ui.label/version @config/VERSION)]]]]])
